import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from '@core/feature';
import { DeviceService, UserAgentService } from '@shared/services';
import { BREAKPOINT } from '@spartacus/storefront';
import { ClientId } from '@user/const';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

/** Интерсептор написан, чтобы для входа через смс подсовывать аксес тайп в запрос.
    Кроме этого, он подставляет клиент ИД и уникальный ключ клиента
*/
@Injectable({ providedIn: 'root' })
export class AuthTypeInterceptor implements HttpInterceptor {
  constructor(
    private userAgentService: UserAgentService,
    private deviceService: DeviceService,
    private cookieService: CookieService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let body = req.body;

    if (body?.get?.('client_id')) {
      return this.userAgentService.breakpoint$.pipe(
        first(),
        switchMap((breakpoint: BREAKPOINT) => {
          if (req.url.includes('/oauth/token')) {
            const username = req.body.get('username');

            if (username) {
              const userNameWithTypeArray = username.split('&');
              const isCode = userNameWithTypeArray[1] === 'true';
              body = body.set('username', userNameWithTypeArray[0]);

              if (isCode) {
                body = body.set('access_type', 'access_code');
              }
            }
          }
          const instanceUid = this.cookieService.get('instance-uid');

          const appClientId = this.deviceService.getAppClientId();
          const clientId = appClientId ?? ClientId[breakpoint];

          const paramReq = req.clone({
            body: body.set('client_id', clientId).set('instance_uid', instanceUid),
          });

          return next.handle(paramReq);
        }),
      );
    }

    return next.handle(req);
  }
}
